import { render } from "./ProjectInfo.vue?vue&type=template&id=9a83f208&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=9a83f208&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a83f208"],['__file',"src/views/h5/crm/project/manage/ProjectInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a83f208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a83f208', __exports__)) {
    api.reload('9a83f208', __exports__)
  }
  
  module.hot.accept("./ProjectInfo.vue?vue&type=template&id=9a83f208&scoped=true", () => {
    api.rerender('9a83f208', render)
  })

}


export default __exports__